import React, { Fragment } from "react"

const REPLACE_TEMPLATE = "[TEXT_REPLACEMENT]"

const textHighlight = (text, highlight) => {
  if (!text || typeof text !== "string") return ""
  if (!highlight || typeof highlight !== "string") return text

  const highlightIndex = text.indexOf(highlight)

  if (highlightIndex > -1) {
    const textTemplate = text.replaceAll(highlight, REPLACE_TEMPLATE)
    const textSplit = textTemplate.split(" ")

    return textSplit.map((string, index) =>
      string === REPLACE_TEMPLATE ? (
        <span key={index}>{highlight} </span>
      ) : (
        <Fragment key={index}>{string} </Fragment>
      )
    )
  } else {
    return text
  }
}

export default textHighlight
